import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { InertiaLink } from "@inertiajs/inertia-react";

const navigation = [
    {
        name: "Waarom WE ARE",
        href: route("about"),
        current: route().current("about"),
    },
    {
        name: "Resultaten",
        href: route("results"),
        current: route().current("results"),
    },
    {
        name: "Verhalen",
        href: route("stories"),
        current: route().current("stories"),
    },
    // {
    //     name: "Werken bij",
    //     href: route("work-at"),
    //     current: route().current("work-at"),
    // },

    // {
    //     name: "Blogs",
    //     href: route("blogs.index"),
    //     current: route().current("blogs.*"),
    // },
    {
        name: "De WE ARE Methode",
        href: route("twelve-week-program"),
        current: false,
    },
    {
        name: "FAQ",
        href: route("faq"),
        current: route().current("faq"),
    },
];

export default function Example() {
    return (
        <div className="relative bg-black top-0">
            <Popover className="relative bg-black shadow">
                <div className="max-w-7xl mx-auto px-4 sm:px-6">
                    <div className="flex justify-between items-center py-4 md:justify-start md:space-x-10">
                        <div className="flex justify-start lg:w-0 lg:flex-1">
                            <a href="/">
                                <span className="sr-only">WE ARE</span>
                                <img
                                    className="h-14 w-14"
                                    src="/assets/personal-training-uden-schijndel.svg"
                                    alt="WE ARE logo"
                                />
                            </a>
                        </div>

                        <div className="-mr-2 -my-2 md:hidden">
                            <Popover.Button className="bg-we-are-yellow rounded-md p-2 inline-flex items-center justify-center text-black">
                                <span className="sr-only">Open menu</span>
                                <MenuIcon
                                    className="h-6 w-6"
                                    aria-hidden="true"
                                />
                            </Popover.Button>
                        </div>

                        <div className="hidden md:flex items-center flex-1 grow-[2] justify-end lg:w-0">
                            {navigation &&
                                navigation.map((item, index) => (
                                    <div key={index}>
                                        {(item.name !== "De WE ARE Methode" && (
                                            <a
                                                className={`${
                                                    item.current
                                                        ? "text-we-are-yellow font-medium"
                                                        : "text-white hover:text-we-are-yellow"
                                                } w-full uppercase border-transparent hover:text-gold cursor-pointer inline-flex items-center m-3 border-b-2 text-md font-medium`}
                                                href={item.href}
                                            >
                                                {item.name}
                                            </a>
                                        )) || (
                                            <a
                                                className="inline-flex ml-2 items-center px-3 py-3 border border-transparent text-md leading-4 font-medium uppercase rounded-md shadow-sm text-black bg-we-are-yellow hover:bg-we-are-purple hover:text-white"
                                                href={item.href}
                                            >
                                                {item.name}
                                            </a>
                                        )}
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>

                <Transition
                    as={Fragment}
                    enter="duration-200 ease-out"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="duration-100 ease-in"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <Popover.Panel
                        focus
                        className="absolute top-0 inset-x-0 z-10 transition transform origin-top-right md:hidden"
                    >
                        <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-black divide-y-2 divide-gray-50">
                            <div className="pt-5 pb-6 px-5">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <img
                                            className="h-8 w-auto"
                                            src="/assets/personal-training-uden-schijndel.svg"
                                            alt="WE ARE logo"
                                        />
                                    </div>
                                    <div className="-mr-2">
                                        <Popover.Button className="bg-black rounded-md p-2 inline-flex items-center justify-center text-gray-100 hover:text-gray-300">
                                            <span className="sr-only">
                                                Close menu
                                            </span>
                                            <XIcon
                                                className="h-6 w-6"
                                                aria-hidden="true"
                                            />
                                        </Popover.Button>
                                    </div>
                                </div>
                                <div className="mt-6">
                                    <nav className="grid gap-y-8">
                                        {navigation &&
                                            navigation.map((item, index) => (
                                                <div key={index}>
                                                    {(item.name !==
                                                        "Twaalf weken programma" && (
                                                        <InertiaLink
                                                            className={`${
                                                                item.current
                                                                    ? "text-we-are-yellow font-medium"
                                                                    : "text-white hover:text-we-are-yellow"
                                                            } border-transparent hover:text-gold cursor-pointer inline-flex items-center m-3 border-b-2 text-md font-medium`}
                                                            href={item.href}
                                                        >
                                                            {item.name}
                                                        </InertiaLink>
                                                    )) || (
                                                        <a
                                                            className="inline-flex ml-2 items-center px-3 py-3 border border-transparent text-md leading-4 font-medium uppercase rounded-md shadow-sm text-black bg-we-are-yellow hover:bg-we-are-purple hover:text-white"
                                                            href={item.href}
                                                            target="_blank"
                                                        >
                                                            {item.name}
                                                        </a>
                                                    )}
                                                </div>
                                            ))}
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </Popover.Panel>
                </Transition>
            </Popover>
        </div>
    );
}
